import { getGenericFormInitialValues } from "../../../components/form/utils/initialValues";

export const getBmsCopayFormInitialValues = ({ applicationForm, formJson }) => {
  const initialValues = getGenericFormInitialValues(applicationForm, formJson);
  return initialValues;
};
